module.exports = __webpack_public_path__ + "static/img/年度最佳创新硬件.5b62afb0.png";